module.exports = {
    DEVICE_TYPE: "W",
    API_URL: process.env.REACT_APP_BACKEND_API_URL,
    SERVER_FILE_PATH: process.env.REACT_APP_SERVER_FILE_PATH,
    CRYPTO_SECRET_KEY: "ztohxhkzvgxzjxgyzzmg",
    DEFAULT_CURRENCY: "$",
    FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
    FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    FIREBASE_MESSAGING_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID,
    FIREBASE_MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    FIREBASE_VAPID_KEY: process.env.REACT_APP_FIREBASE_VAPID_KEY,
    SUPER_ADMIN_ROLE_SLUG: "super_admin",
    NOTIFICATION_ROLE_LIST: [
      { slug: 'all', name: "All" },
      { slug: 'teacher', name: "All Service Provider" },
      { slug: 'student', name: "All Client" },
      { slug: 'custom', name: "Custom" }
    ],
    STATUS_LIST: [
      { id: '0', name: "Pending" },
      { id: '1', name: "Completed" },
    ],
    TRANSACTION_TYPE: [
      { slug: 'semester', name: "Semester" },
      { slug: 'lesson', name: "Lesson" },
      { slug: 'subscription', name: "Subscription" },
      { slug: 'unknown', name: "Unknown" },
    ],
    PAYMENT_STATUS: [
      { slug: 'pending', name: "Pending" },
      { slug: 'success', name: "Success" },
      { slug: 'fail', name: "Fail" }
    ],
    PAYMENT_TYPE: [
      { slug: 'cash', name: "Cash" },
      { slug: 'cheque', name: "Check" },
      { slug: 'zelle', name: "Zelle" },
      { slug: 'paypal', name: "PayPal" },
      { slug: 'venmo', name: "Venmo" },
    ],
    SUBSCRIPTION_STATUS_LIST: [
      { id: '0', name: "Inactive" },
      { id: '1', name: "Active" },
    ],
    UNDER_AGE_LIST: [
      { id: '1', name: "True" },
      { id: '0', name: "False" },
    ],
  };